import React from 'react';

import { useLocation } from 'react-router-dom';
import CompaniesList from './CompaniesList';
import CompanyDetails from './CompaniesList/CompanyDetails';
import classes from './styles.module.scss';

export default function Companies() {
  const location = useLocation();
  return (
    <div className={classes.Companies}>
      {location.pathname.includes('company-details') ? (
        <CompanyDetails />
      ) : (
        <CompaniesList />
      )}
    </div>
  );
}
